import type { MutableRefObject, ReactNode } from 'react'
import { forwardRef } from 'react'

import { HcCollapseItem } from '@hotmart-org-ca/cosmos-web/dist/react/hc-collapse'

import { useShadowRef } from '../hooks/useShadowRef'

type CollapseItemProps = {
  children: ReactNode
  className: string
  active: boolean
}

const CollapseItem = forwardRef(({ children, className, active }: CollapseItemProps, ref) => {
  const { shadowRootRef } = useShadowRef(ref as MutableRefObject<HTMLHcCollapseItemElement>)

  return (
    <HcCollapseItem class={className} active={active} ref={shadowRootRef}>
      {children}
    </HcCollapseItem>
  )
})

export default CollapseItem
